import * as React from "react";

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} viewBox="0 0 64 64" {...props}>
      {/* Blue Circular Background */}
      <circle cx="32" cy="32" r="32" fill="#2d79c7" />

      {/* Long Shadow */}
      <path
        d="M32 32l15 15H17L32 32z"
        fill="rgba(0, 0, 0, 0.2)"
      />

      {/* Left Curly Brace */}
      <path
        d="M22 18c-2 2-2 4-2 6s0 4 2 6-2 4-2 6 0 4 2 6"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Right Curly Brace */}
      <path
        d="M42 18c2 2 2 4 2 6s0 4-2 6 2 4 2 6 0 4-2 6"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Pencil */}
      <path
        d="M28 28l8 8"
        fill="none"
        stroke="#fff"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <rect
        x="28"
        y="27"
        width="2"
        height="10"
        transform="rotate(-45 32 32)"
        fill="#fff"
      />
      <circle cx="31" cy="31" r="1.5" fill="#2d79c7" />
    </svg>
  );
}

export default SvgComponent;
